import React from 'react'
import { Zap, Users, Clock, FileText, MessageSquare } from 'lucide-react';
/* Instance Message Css Line 1080 start  TeamCollaboration.css*/
import { Helmet } from 'react-helmet';

export default function InstanceMessage_TopLevel() {
    const features = [
        {
            icon: Zap,
            title: "Instant Delivery",
            subtitle: "Real-Time",
            rotation: 0
        },
        {
            icon: Users,
            title: "Unlimited",
            subtitle: "Group Chats",
            rotation: -1.35
        },
        {
            icon: Clock,
            title: "Messages",
            subtitle: "Scheduled",
            rotation: -0.98
        },
        {
            icon: FileText,
            title: "Quick Replies",
            subtitle: "Templates",
            rotation: -1.91
        }
    ];
    return (
        <section className="chat-hero">
            <Helmet>
                <title>
                    Communicate at the
                    Speed of Thought | Simplifyte
                </title>
            </Helmet>
            {/* Background blur effects */}
            <div className="chat-hero-background">
                <div className="blob-1"></div>
                <div className="blob-2"></div>
            </div>

            <div className="chat-hero-container">
                {/* Header content */}
                <div className="chat-hero-content">
                    {/* Instant Messaging badge */}
                    <div className="chat-badge">
                        <MessageSquare className="badge-icon" />
                        <span className='chat-badge-text'>Instant Messaging</span>
                    </div>

                    {/* Main heading */}
                    <h1 className="chat-title">
                        Communicate at the
                        <br />
                        <span className="gradient-text">Speed of Thought</span>
                    </h1>

                    {/* Description */}
                    <p className="chat-description">
                        Stay connected with real-time chat, making team communication faster
                        and more efficient. No need for external messaging apps—everything
                        happens right here.
                    </p>

                    {/* Features grid */}
                    <div className="features-grid">
                        {features.map((feature, index) => {
                            const IconComponent = feature.icon;
                            return (
                                <div
                                    key={index}
                                    className="feature-card"
                                // style={{ transform: `rotate(${feature.rotation}deg)` }}
                                >
                                    <div className="feature-icon-wrapper">
                                        <IconComponent className="feature-icon" />
                                    </div>
                                    <h3 className="feature-title">{feature.title}</h3>
                                    <p className="feature-subtitle">{feature.subtitle}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    )
}
